import { Component, Inject, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';

import { Store } from '@src/store';
import { DialogManagerService } from '@src/services';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { consts } from '@src/constants/consts';
import { projectsActions } from '@src/store/reducers/projectsReducer';
import { scriptsActions } from '@src/store/reducers/scriptsReducer';
import { packagesActions } from '@src/store/reducers/packagesReducer';

import lodash from 'lodash';
import * as _str from 'underscore.string';
import { testThemeStatuses } from '@src/constants';

@Component({
    selector: 'packages-list',
    template: require('./packages-list.component.html'),
    styles: [require('./packages-list.component.scss')]
})
export class PackagesListComponent implements OnInit, OnDestroy {
    @Input() public selectedPackage: any;
    @Input() public collapsed: any;
    @Input() public projectWithMetaData: any;
    @Input() public packageTagsList: any;
    @Input() public tagTypes: any;

    @Output() public onUp = new EventEmitter<any>();
    @Output() public onDown = new EventEmitter<any>();
    @Output() public onAdhocSettingChanged = new EventEmitter();
    @Output() public onScriptTypeChanged = new EventEmitter<any>();
    @Output() public onScriptTypeMoved = new EventEmitter<any>();

    public projectId: any;
    public disabled = false;
    public currentTestResponse: any = { theme: '', text: '' };
    public reset: any = null;
    public isCollapsedUp = true;
    public isCollapsedDown = true;
    public selectedScriptType: any;
    public scripts: any;
    public showAffectedObjects: any;
    public useDowngradeScripts: any;
    public oldSelectedPackage: any;

    private canEditPackageScripts: any;
    private unsubscribe: any;
    private _selectedpackage: any;
    private deployOn: any;

    public packageActions = [
        { Title: 'PreCheck', Key: 'Precheck' },
        { Title: 'Transfer Up', Key: 'Promote' },
        { Title: 'Transfer Down', Key: 'Demote' },
        { Title: 'View Activities', Key: 'ViewActivities' }
    ];

    constructor(
        @Inject('$scope') private $scope: any,
        private store: Store,
        @Inject('$stateParams') $stateParams: any,
        private dialogManagerService: DialogManagerService,
        private translatePipe: TranslatePipe,
        @Inject('authorizationService') authorizationService: any,
        @Inject('dbTypeService') private dbTypeService: any) {
        this.projectId = $stateParams.id;
        authorizationService.isAuthorizedToPerformAction(consts.userPermissions.UpdateScript)
            .then((canEditPackageScripts: any) =>
            setTimeout(() => { this.canEditPackageScripts = canEditPackageScripts; }, 50)
        );

        this.unsubscribe = this.store.subscribe(() => {
            const scriptState = this.store.getState().scripts;
            if (scriptState && scriptState.scriptData && this.scripts && this.scripts.length > 0) {
                const scriptState = this.store.getState().scripts.scriptData;
                const element = this.scripts.find((x: any) => x.scriptId === scriptState.id);
                if (element) {
                    element.warnings = lodash.cloneDeep(scriptState).warnings;
                }
                this.store.dispatch({ type: scriptsActions.REST_SCRIPT_DATA });
            }
        });
    }

    public ngOnDestroy() {
        this.unsubscribe();
        delete window.onresize;
    }

    public async ngOnInit() {
        this.changeScriptType(1);
        const { data } = await this.store.dispatch({
            type: projectsActions.GET_PROJECT_META_DATA,
            payload: { projId: this.projectId }
        });
        this.loadShowAffectedObjectsFlag(data.dbTypeId, data.options.UseDowngradeScripts);
        this.$scope.$watch(() => this.selectedPackage, async (newVal: any) => {
            if (newVal) {
                this.oldSelectedPackage = this._selectedpackage;
                this._selectedpackage = newVal;
                await this.initSelectedPackage(newVal);
            }
        });
    }

    public changeScriptType(type: any) {
        this.selectedScriptType = type-1;
        this.onScriptTypeChanged.emit(type);
    }

    public moveScriptType(script: any) {
        const scriptType = script.scriptType === 1 ? 2 : 1;
        const onSuccess = () => {
            for (let i = 0; i < this.scripts.length; i++) {
                if (this.scripts[i].scriptId === script.scriptId) {
                    this.scripts.splice(i, 1);
                    i--;
                }
            }
            script.scriptType = scriptType;
            this.scripts.push(script);
        };
        this.onScriptTypeMoved.emit({ script, scriptType, callback: onSuccess });
    }

    private async initSelectedPackage(selectedPackage: any) {
        
        const response = await this.store.dispatch({
            type: packagesActions.GET_PACKAGE_INFO,
            payload: { projectId: this.projectId, packageId: this._selectedpackage.id }
        });
        if (response.data && response.data.length > 0) {
            let { 0: first } = response.data;
            selectedPackage = first;
            const _packages = this.store.getState().packageManager.packages;
            if (_packages && _packages.length > 0) {
                const packageState = _packages.find((x: any) => x.id == selectedPackage.id);
                packageState.scripts = lodash.cloneDeep(selectedPackage.scripts);
                this.store.dispatch({
                    type: packagesActions.SET_PACKAGES,
                    payload: { packages: _packages, no_items_packages: false }
                });
            }
            await this.loadCurrentTestTheme();
            if (selectedPackage && 'undefined' === typeof selectedPackage.isEnabled) {
                selectedPackage.isEnabled = true;
            }
            this.scripts = lodash.cloneDeep(selectedPackage.scripts);
            if(this.store.getState().projects && this.store.getState().projects.projectWithMetaData && this.store.getState().projects.projectWithMetaData.options)
                //check that project isn't using downgrades and also that its not a rollback (temporary) package then hides the downgrade scripts
                if(!this.store.getState().projects.projectWithMetaData.options.UseDowngradeScripts && !this.selectedPackage.isTemporary)
                    this.scripts = this.scripts.filter( elem =>{
                        return elem.scriptType !== 2
                    })
            if (selectedPackage.packageState != 0) {
                this.deployOn = selectedPackage.scripts.map((item: any) => item.schemaName);
                this.deployOn = lodash.uniq(this.deployOn).join(',');
            }
            //checks if this package is rollback but the last one was regualr then change the default tab to downgrade
            if(this.oldSelectedPackage)
            {
                if (this.selectedPackage.isTemporary && !this.oldSelectedPackage.isTemporary){
                    this.changeScriptType(2);
                }
                //checks if this package is regular but the last one was rollback then change the default tab to downgrade
                if (!this.selectedPackage.isTemporary && this.oldSelectedPackage.isTemporary){
                    this.changeScriptType(1);
                }
            }
            setTimeout(() => {
                const broadcastData = {
                    packageId: selectedPackage.id,
                    packageExclusions: selectedPackage.exclusions,
                    isUserExclusionsAuthorized: selectedPackage.isUserExclusionsAuthorized
                };
                this.$scope.$broadcast(consts.emitedEventsTypes.selectedPackageEvent, broadcastData);
            }, 50);
        }
    }

    private loadShowAffectedObjectsFlag(dbtypeId: any, useDowngradeScripts: any) {
        this.dbTypeService.getFlags(dbtypeId).then((data: any) => {
            this.showAffectedObjects = data;
            this.useDowngradeScripts = !data.HasDevEnv || useDowngradeScripts;
        });
    }

    public onRemove(script: any) {
        if (this._selectedpackage && this._selectedpackage.packageState == 0) {
            const payload = { projectId: this.projectId, packageId: this._selectedpackage.id, scriptId: script.scriptId };
            this.store.dispatch({ type: packagesActions.REMOVE_SCRIPT_TO_PACKAGE, payload });
        }
    }

    public showScript(script: any, isDefaultEdit = false) {
        const scope = this.$scope;
        const onScriptSaved = () => {
            scope.$broadcast(consts.emitedEventsTypes.scriptEdit, { packageId: this._selectedpackage.id });
        };
        this.dialogManagerService.showScriptViewerDialog({
            isDefaultEdit,
            dispatch: (action: any) => this.store.dispatch(action),
            projectId: this.projectId,
            packageId: script.versionid,
            scriptId: script.scriptId,
            isEnabled: script.IsEnabled,
            isPackageMode: this._selectedpackage && this._selectedpackage.packageState == 0,
            canEditPackageScripts: this.projectWithMetaData.canEditPackageScripts && this.canEditPackageScripts
        }, onScriptSaved);
    }

    public setAdhocForPackage() {
        if (this._selectedpackage && this._selectedpackage.packageState == 0) { // just open package and tmp package
            this.store.dispatch({
                type: packagesActions.SET_IS_ADHOC_FOR_PACKAGE,
                payload: {
                    projectId: this.projectId,
                    packageId: this._selectedpackage.id,
                    isAdhocPackage: this._selectedpackage.isAdhocPackage || false
                },
                callback: (error: any) => {
                    if (error.status !== 200) {
                        this._selectedpackage.isAdhocPackage = !this._selectedpackage.isAdhocPackage;
                    } else {
                        this.onAdhocSettingChanged.emit();
                    }
                }
            });
        }
    }

    public async loadCurrentTestTheme() {
        const themeState = testThemeStatuses[this._selectedpackage.testResults];
        if (!this.currentTestResponse) {
            this.currentTestResponse = { theme: '', text: '' };
        }
        this.currentTestResponse.theme = (typeof themeState === 'function' ? themeState() : themeState);
        const translations = await this.translatePipe.transform(this._selectedpackage.testResults);
        this.currentTestResponse.text = translations;
    }

    public setEnableOrDisableForPackage() {
        if (this._selectedpackage && this._selectedpackage.packageState == 0
            || this._selectedpackage.isTemporary) { // just open package and tmp package
            this.store.dispatch({
                type: packagesActions.SET_ENABLE_OR_DISABLE_FOR_PACKAGE,
                payload: {
                    projectId: this.projectId,
                    packageId: this._selectedpackage.id,
                    isEnabled: { isEnabled: this._selectedpackage.isEnabled }
                },
                callback: (error: any) => {
                    if (error.status !== 200) {
                        this._selectedpackage.isEnabled = !this._selectedpackage.isEnabled;
                    }
                }
            });
        }
    }

    private runPrecheck() {
        this.store.dispatch({
            type: packagesActions.TEST_PACKAGE,
            payload: { projectId: this.projectId, packageId: this._selectedpackage.id },
            callback: () => { }
        });
    }

    public checkScript() { //script: any) {
        // TODO showWarning from common
        //showWarning(script, this.projectId, this.popUpModal, this.store, this.showScript, this.refreshScripts);
    }

    /*private refreshScripts(scriptId: any) {
        const payload = { projectId: this.projectId, packageId: this._selectedpackage.id, scriptId };
        this.store.dispatch({ type: scriptsActions.GET_SCRIPT_DATA, payload: payload });
    }*/

    private openActivitiesWindow() {
        this.$scope.$broadcast(consts.emitedEventsTypes.openActivitiesWindow);
    }

    public async clickPkgAction(pkgAction: any) {
        if (pkgAction.Key === 'Precheck') {
            this.runPrecheck();
            return;
        }

        if (pkgAction.Key === 'ViewActivities') {
            this.openActivitiesWindow();
            return;
        }

        const response = await this.store.dispatch({
            type: packagesActions.GET_VERSION_SUGGESTED_FOR_PROMOTIONS,
            payload: {
                projectId: this.projectId,
                packageId: this._selectedpackage.id,
                action: pkgAction.Key
            }
        });

        if (response && response.length > 0) {
            this.dialogManagerService.showPackagePromotionDialog(
                {
                    title: pkgAction.Title,
                    targetProjectId: '',
                    suggestedVersion: '',
                    targetProjectsList: response,
                    action: pkgAction.Key
                },
                (data: any) => {
                    this.promoteDemotePackage({ ...data });
                }
            );
        } else {
            const translations = await this.translatePipe.transform([
                'ERROR_NO_DATA_FOR_PROMOTE_DEMOTE',
                'ERROR_OCCURRED'
            ]);
            const messageFormat = translations['ERROR_NO_DATA_FOR_PROMOTE_DEMOTE'];
            const message = _str.sprintf(messageFormat, pkgAction.Title);
            this.dialogManagerService.showErrorDialog({ title: translations['ERROR_OCCURRED'], text: message });
        }
    }

    private async promoteDemotePackage({ targetProjectId, suggestedVersion, action }) {
        if (!targetProjectId) {
            const translations = await this.translatePipe.transform([
                'ERROR_OCCURRED',
                'ERROR_NO_PARAMETERS_FOR_PROMOTE_DEMOTE'
            ]);
            this.dialogManagerService.showErrorDialog({
                title: translations['ERROR_OCCURRED'],
                text: translations['ERROR_NO_PARAMETERS_FOR_PROMOTE_DEMOTE']
            });
        } else {
            this.store.dispatch({
                type: packagesActions.PROMOTE_DEMOTE_PACKAGE,
                payload: {
                    targetProjectId,
                    action,
                    projectId: this.projectId,
                    packageId: this._selectedpackage.id,
                    targetPackage: suggestedVersion
                }
            });
        }
    }
    //prints the sequence for downgrade and upgrade seperately
    printSequence(script)
    {
        const scriptsWithType = this.scripts.filter(scr => {
            return scr.scriptType == script.scriptType;
        })
        const sequence = scriptsWithType.indexOf(script);
        //start from 1 and not from 0
        return sequence+1;

    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/packageManager/packages/packages-list/packages-list.component.ts